import { ChevronRight, KeyboardArrowDown } from '@material-ui/icons';
import QRDownloader from 'components/Utility/QRDownloader';
import URLPreview from 'components/Utility/URLPreview';
import React from 'react';
import styled from 'styled-components';
import Joined from '../../../MenuEditor/components/shared/Joined';
import JoinedGroup from '../../../MenuEditor/components/shared/JoinedGroup';
import getServiceTypeLabel from './utils/getServiceTypeLabel';

const SectionWrapper = styled.div`
  background: #ffffff;
  border-bottom: 1px solid #eeeeee;
  padding-left: 12px;
`;
const OptionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

const Container = styled.div`
  margin-left: 32px;
  margin-top: 30px;
  margin-bottom: 30px;

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
  }
`;

const BigUrl = styled.div`
  margin-top: 20px;
  margin-bottom: 35px;

  @media (max-width: 900px) {
    width: 90%;
  }
`;

const ArrowDiv = styled.div`
  @media (max-width: 900px) {
    margin-top: -4px;
  }
`;

function GroupParticipantView({ group }) {
  const [showResults, setShowResults] = React.useState(false);
  const toggleResults = () => {
    setShowResults(!showResults);
  };

  return (
    <SectionWrapper>
      <OptionWrapper>
        <JoinedGroup
          dGroup
          variant="outlined"
          color="primary"
          onClick={toggleResults}
        >
          <ArrowDiv>
            {showResults ? (
              <KeyboardArrowDown
                style={{ fontSize: 25, marginTop: 4, marginRight: 1 }}
              />
            ) : (
              <ChevronRight
                style={{ fontSize: 25, marginTop: 4, marginRight: 1 }}
              />
            )}
          </ArrowDiv>
          {group.name}
        </JoinedGroup>

        <Joined variant="outlined" color="primary">
          Joined
        </Joined>
      </OptionWrapper>

      {!showResults ? (
        <p></p>
      ) : (
        <Container>
          <div
            className="settings__section__subheading"
            style={{ fontSize: '16px' }}
          >
            Service type
          </div>
          <p style={{ marginBottom: 35, fontSize: '15px' }}>
            {getServiceTypeLabel(group.serviceType)}
          </p>

          <div
            className="settings__section__subheading"
            style={{ fontSize: '16px' }}
          >
            Tabb page URL
          </div>

          <BigUrl>
            <URLPreview>{`${process.env.REACT_APP_CUSTOMER_APP_URL}/m/${group.slug}`}</URLPreview>
          </BigUrl>

          <div
            className="settings__section__subheading"
            style={{ fontSize: '16px' }}
          >
            QR Code
          </div>

          <div style={{ marginTop: 20 }}>
            <QRDownloader
              url={`${process.env.REACT_APP_CUSTOMER_APP_URL}/m/${group.slug}`}
            ></QRDownloader>
          </div>
        </Container>
      )}
    </SectionWrapper>
  );
}

export default GroupParticipantView;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MultiVenue/components/GroupDetails/GroupParticipantView.jsx